function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedrightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.029,
    viewBox: "0 0 24 24.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17140",
    transform: "translate(20915 21717.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 920",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(-20915 -21717)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "arrow-right (1)",
    d: "M22.77 10.75a12.018 12.018 0 1 0 9.792 18.982A12.017 12.017 0 0 0 22.77 10.75zm5.764 12.658-3.276 3.355a.919.919 0 0 1-1.314-1.283l1.656-1.693h-7.836a1.02 1.02 0 1 1 0-2.041h7.794l-1.686-1.685a.919.919 0 0 1 1.3-1.3l3.356 3.355a.918.918 0 0 1 .008 1.291z",
    transform: "translate(-10.756 -10.749)",
    style: {
      fill: "#bf2600"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedrightarrow);
export default __webpack_public_path__ + "static/media/redrightarrow.5f4631c579232cb9395623622436241f.svg";
export { ForwardRef as ReactComponent };